// extracted by mini-css-extract-plugin
export var cancelButton = "_ot-5";
export var content = "_ot-3";
export var createButton = "_ot-6";
export var drawerContainer = "_ot-0";
export var footer = "_ot-2";
export var header = "_ot-1";
export var orderFormColumn = "_ot-4";